module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_hazel.fe3b5f01.png";